import { useDispatch } from "react-redux";
import AllRoutes from "./Routes/AllRoutes";
import { checkAuth } from "./Store/Slices/AuthSlice";
import { useLayoutEffect } from "react";

function App() {
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(checkAuth());
  }, [dispatch]);

  return (
    <>
      <AllRoutes />
    </>
  );
}

export default App;
